<template>            
  <RightSideBar @close="$emit('close')" button-class="bg-dynamicBackBtn text-white" :submit="'Save'" :cancel="'Cancel'" :loading="isLoading" @submit="submit" :disabled-button="!isUploaded">
    <template v-slot:title>
      <div class="text-darkPurple flex gap-2 justify-center items-center">
          <div @click="closeSidebar()"><icon icon-name="back_arrow" size="s" class="w-8 h-8 rounded text-romanSilver"/></div> 
          <p class="font-bold">Upload File(s)</p>    
      </div>
    </template>

    <div
      ref="dropContainer"
      @dragover.prevent="dragOver"
      @dragleave.prevent="dragLeave"
      @drop.prevent="handleDropFiles"
      class="w-full mt-4 border border-dashed border-romanSilver bg-white flex flex-col justify-center items-center gap-4 py-4 rounded-md"
    >
      <icon icon-name="storage" size="s" class="storage"/>
      <p ref="dropFirstChild"
        class="w-2/3 mx-auto text-center flex flex-col justify-center items-center text-darkPurple"
      >
          <span ref="dropFirstInner">Drag and drop files here</span>
          <span>OR</span>
      </p>
      <Button ref="btnDrop"
        @click="triggerInputFile" 
        class="text-white rounded-md bg-dynamicBackBtn flex flex-col justify-center items-center w-28 h-9"
      >
          Browse Files
      </Button>
      <input v-if="showInput" type="file" @change="handleInputFiles" ref="fileInput" multiple hidden>
      <p class="text-romanSilver text-xs">*supported file type: pdf, doc, xlsx, csv, ppt and png or jpg.</p>
    </div>

    <div v-if="uploading"  class="w-full h-auto flex flex-col justify-center items-center gap-3 mt-4">
      <div class="w-full border border-dashed border-romanSilver" />
      <p class="w-full  my-4 text-left uppercase font-semibold text-romanSilver text-xs">Uploading</p>
      <p class="w-full text-center uppercase font-black text-jet text-xs">
        Upload in Progress
      </p>
      <div class="line" />

      <div class="w-full h-9 flex justify-between items-center gap-6">
        <div class="w-auto h-full flex justify-start items-center gap-3">
          <div class="w-9 h-full">
            <icon icon-name="pdf" size="xs" class="icon" v-if="fileType === 'pdf'"/>
            <icon icon-name="doc" size="xs" class="icon" v-else-if="fileType === 'doc'"/>
            <icon icon-name="xlsx" size="xs" class="icon" v-else-if="fileType === 'xlsx'"/>
            <icon icon-name="csv" size="xs" class="icon" v-else-if="fileType === 'csv'"/>
            <icon icon-name="ppt" size="xs" class="icon" v-else-if="fileType === 'ppt'"/>
            <icon icon-name="png" size="xs" class="icon" v-else-if="fileType === 'png'"/>
            <icon icon-name="jpg" size="xs" class="icon" v-else-if="fileType === 'jpg'"/>
            <icon icon-name="jpg" size="xs" class="icon" v-else-if="fileType === 'jpeg'"/>
          </div>

          <div class="flex flex-col justify-center items-start">
            <p class="text-blackJet text-base font-semibold py-0 my-0">{{ fileName }} {{ fileType }}</p>
            <p v-if="networkError" class="text-xs py-0 my-0">
                <span class="text-desire">
                    Upload Interrupted
                </span>
                <span class="text-romanSilver "> 
                    • ---
                </span>
            </p>
          </div>
        </div>

        <div class="flex gap-1">
          <div v-if="networkError" @click="retryUpload" class="cursor-pointer h-full w-9">
              <icon icon-name="icon-undo" size="s" class="icon"/>
          </div>
          <div @click="cancelUpload" class="cursor-pointer h-full w-9">   
              <icon icon-name="icon-close" size="s" class="icon"/>
          </div>
        </div>
      </div>
    </div>

    <div v-if="isUploaded" class="w-full h-auto flex flex-col gap-4 my-4">
      <div class="w-full border border-dashed border-romanSilver" />
      <p class="w-full text-left uppercase font-semibold text-romanSilver text-xs">Uploaded Files</p>

      <div v-if="files.length > 0" class="w-full h-auto flex flex-col gap-4">
        <div v-for="(file, index) in files" :key="index" 
          class="w-full h-9 flex justify-between items-center gap-6"
        >
          <div class="w-auto h-full flex justify-start items-center gap-3">
            <div class="w-9 h-full">
              <icon icon-name="pdf" size="xs" class="icon" v-if="file.mimeType === 'pdf'"/>
              <icon icon-name="doc" size="xs" class="icon" v-else-if="file.mimeType === 'doc'"/>
              <icon icon-name="xlsx" size="xs" class="icon" v-else-if="file.mimeType === 'xlsx'"/>
              <icon icon-name="csv" size="xs" class="icon" v-else-if="file.mimeType === 'csv'"/>
              <icon icon-name="ppt" size="xs" class="icon" v-else-if="file.mimeType === 'ppt'"/>
              <icon icon-name="png" size="xs" class="icon" v-else-if="file.mimeType === 'png'"/>
              <icon icon-name="jpg" size="xs" class="icon" v-else-if="file.mimeType === 'jpg'"/>
              <icon icon-name="jpg" size="xs" class="icon" v-else-if="file.mimeType === 'jpeg'"/>
            </div>

            <div class="flex flex-col justify-center items-start">
              <p class="text-blackJet text-base font-semibold py-0 my-0">{{ file.fileName }} {{ file.mimeType }}</p>
              <p class="text-xs py-0 my-0">
                  <span class="text-blueCrayola">
                      {{ `document` }}
                  </span>
                  <span class="text-romanSilver "> 
                      • {{ file.fileSize.toFixed(2) }}
                  </span>
              </p>
            </div>
          </div>
          <div @click="deleteUploadedFile(index)" class="cursor-pointer h-full w-9">
            <icon icon-name="trash-icon" size="s" class="icon"/>
          </div>    
        </div>
      </div>
    </div>
  </RightSideBar>
</template>

<script>
import axios from 'axios';
import RightSideBar from "./RightSideBar";
import Card from "./Card";
import CSelect from "@scelloo/cloudenly-ui/src/components/select"

export default {
  name: "UploadFile",
  components: {
    RightSideBar,
    CSelect,
    Card
  },
  data() {
    return {
      showInput: true,
      selected: "",
      tags: "",
      isLoading: false,
      optionsBox: [],
      isUploaded: false,
      folderName: "",
      uploading: false,
      networkError: false,
      fileName: '',
      fileType: '',
      uploadFile: null,
      imageSizeMB: 0,
      allFiles: [],
      mimeType: {
        "vnd.openxmlformats-officedocument.spreadsheetml.sheet": "xlsx",
        "vnd.openxmlformats-officedocument.wordprocessingml.document": "doc",
        "vnd.openxmlformats-officedocument.presentationml.presentation": "ppt",
        "vnd.ms-powerpoint": "ppt",
        "pptx": "ppt"
      }
    };
  },
  computed: {
    files() {
      return this.allFiles
    }
  },
  methods: {
    closeSidebar() {
      this.$emit("close");
    },

    triggerInputFile() {
      this.$refs.fileInput.click();
    },

    dragOver(e) {
        e.target.style.background = "#eee";
    }, 

    dragLeave(e) {
        e.target.style.background = "#FFFFFF";
    },

    handleDropFiles(e) {
      const dropRef = this.$refs.dropContainer;
      const dropFirstChild = this.$refs.dropFirstChild;
      const dropFirstInner = this.$refs.dropFirstInner;
      const btnDrop = this.$refs.btnDrop;
      dropRef.style.background = "#FFFFFF";
      dropFirstChild.style.background = "#FFFFFF";
      dropFirstInner.style.background = "#FFFFFF";
      btnDrop.style.background = "#F15A29";
      const files = e.dataTransfer.files;
      const arrayfiles = Array.from(files);
      const totalFiles = this.allFiles.length + arrayfiles.length; 

      if (files.length > 0) {
          if(totalFiles > 5){
            return this.$toasted.error("You can't upload more than 5 files.",
              { duration: 6000}
            );
          }
        this.filesLoop(files)
      } else {
        return this.$toasted.error(
          "Direct file drop from external sites is restricted by browser security.",
          {
              duration: 6000,
          }
        );
      }
    },

    handleInputFiles() {
      const files = this.$refs.fileInput.files;
      const arrayfiles = Array.from(files);
      const totalFiles = this.allFiles.length + arrayfiles.length; 

      if(totalFiles > 5){
        return this.$toasted.error("You can't upload more than 5 files.",
          { duration: 6000,}
        );
      }
      this.filesLoop(files)
    },
    filesLoop(files){
      for(let i = 0; i < files.length; i++){
        this.validateAndUploadFile(files[i]);
      }
    },
    validateAndUploadFile(file) {
      this.uploadFile = file;
      const extension = file.type.split('/').pop().toLowerCase(); // Extract and format file type
      let type = this.mimeType[extension] || extension;
      this.fileType = type;
      const allowedFileType = [ "pdf", "doc", "xlsx", "csv", "ppt", "png", "jpg", "jpeg", "sheet"]

      if(!allowedFileType.includes(type)){
        return this.$toasted.error("Unsupported file type.", { duration: 6000 });
      }else{
        let name = file.name;
        let  extractName = name.substr(0, name.lastIndexOf(".")).replace(/[\d\(\)-]+/g, '')
        const exist = this.files.some(file => file.fileName.toLowerCase() ===  extractName.toLowerCase()) 
        if(exist){
           return this.$toasted.error("File name already exist.", { duration: 6000 });
        }else{
          this.fileUpload(file);
        }
      }
    },

    fileUpload(file) {
      if (!file) return;

      this.reset();
      this.uploadFile = file;
      this.uploadImage(file)
    },

    async uploadImage(file) {
      this.uploading = true;
      const formData = new FormData();
      formData.append('file', file);
      const url = process.env.VUE_APP_IMAGE_UPLOAD;

      try{
          const { data } = await axios.post(url, formData, {
              onUploadProgress: (progressEvent) => {
                  this.imageSizeMB = progressEvent.loaded / 1024 / 1024; // convert to MB
              }
          });
          this.uploadFile = data.fileUrl;
          let name = file.name;
          this.fileName = name.substr(0, name.lastIndexOf(".")).replace(/[\d\(\)-]+/g, '');
          const fileExtension = file.type.split('/').pop().toLowerCase();
          let type = this.mimeType[fileExtension] || fileExtension;
          this.fileType = type;
          this.allFiles.push({ 
              fileUrl: data.fileUrl, 
              fileSize: this.imageSizeMB,
              mimeType: this.fileType,
              fileName: this.fileName,
            });
          this.uploading = false;
          this.isUploaded = true;
      }catch(error){
          this.uploading = true;
          this.networkError = true;
         
      };
    },

    cancelUpload() {
      this.reset();
      this.uploadFile = null;
    },

    deleteUploadedFile(index) {
      if (this.allFiles.length > 1) {
          this.allFiles.splice(index, 1);
      } else {
          this.allFiles.splice(index, 1);
          this.reset();
          this.uploadFile = null;
          this.fileName = '';
          this.fileType = '';
          this.imageSizeMB = 0;
          this.isUploaded = false;
      }
    },

    retryUpload() {
      if (this.uploadFile) {
        this.uploading = false;
        this.networkError = false;
        this.validateAndUploadFile(this.uploadFile);
      }
    },

    reset() {
      this.uploading = false;
      this.networkError = false;
      this.showInput = false;

      this.$nextTick(() => {
        this.showInput = true;
      });
    },

    async submit() {
      this.$emit("set-files", this.files);
      this.closeSidebar();
    },
  },
};
</script>

<style scoped>
.storage{
  width: 80px !important;
  height: 80px !important;
}

.icon{
  width: 100% !important;
  height: 100% !important;
}

.type{
  width: 26.15px;
  height: 13.12px;
  background: #219653;
  position: absolute;
  left: 2px;
  bottom: 6px;
  border-radius: 2px;
  text-align: center;
}

.type p{
  font-size: 10px;
}

.line{
  border: 1px solid #878E99;
  width: 85%;
  height: 0; 
  margin: 14px 0px;
}
</style>